import type { ComponentType, PropsWithChildren } from 'react';

import type { ICreateWidget, TOptions } from './models';
import { hoist, createWrapper } from './helpers';

/**
 * Функция hoc, для создания виджета, принимает объект зависимостей
 * и возвращает компонент с внедренными зависимостями
 */
export const createWidget: ICreateWidget =
    <T, U extends T>(dependencies?: T, options?: TOptions) =>
    (Widget: ComponentType<PropsWithChildren<U>>) =>
        hoist(createWrapper(Widget, dependencies, options), Widget);
